import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  useMediaQuery,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import useTheme from '@mui/styles/useTheme';
import ExpandMore from '@mui/icons-material/ExpandMore';

import {
  getRoleList,
  getRoleDescription,
  getRoleFeatures,
} from '../../../../../utils/rolesHelper';
import styles from './styles';

const useStyles = makeStyles(styles);
const capitalized = (word) => (
  word.charAt(0).toUpperCase()
  + word.slice(1))
export const AboutUserRolesModalComponent = (props) => {
  const fullScreen = useMediaQuery(useTheme().breakpoints.down('sm'));
  const {
    open,
    onClose,
  } = props;
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      aria-labelledby="user-role-info"
      aria-describedby="user-role-info"
      id="user-role-info-dialog"
      className={classes.root}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle id="remove-user-title">Questri Roles</DialogTitle>
      <DialogContent>
        <Typography color="inherit" className={classes.userDescription}>
          By adding a user to the Questri organization, they by default
          get assigned a <b>user</b> role. This role is meant for <b>clients</b> and
          only allows them access to view/edit their profile.
          In addition, these users can also be assigned tasks and
          provide updates on those tasks (Lessons, Rides, Billing, etc.).
        </Typography>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography className={classes.heading}>User (client)</Typography>
            <Typography
              className={classes.secondaryHeading}
              component="div"
            >
              This role is meant for <b>clients</b>. When adding a client to your Questri organization, that user will receive a welcome email
              and be asked to set up a password. Clients will have very limited access to Questri until they are assigned access to a horse.
              <br />
              By adding a client, you will be able to assign them to lesson and riding schedules.
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography component="div">
              Access to web application, view/edit profile, view/edit notification preferences.
            </Typography>
            <Typography component="div">
              Users with only this role WILL NOT have access to the questri mobile access
              unless you assign them to a horse with Client Experience enabled.
            </Typography>
          </AccordionDetails>
        </Accordion>
        {getRoleList().map((role) => (
          <Accordion
            key={role}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography className={classes.heading}>
                {capitalized(role)}
              </Typography>
              <Typography
                className={classes.secondaryHeading}
                component="div"
              >
                {getRoleDescription(role)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography component="div">
                {getRoleFeatures(role).join(', ')}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          id="close-role-info-dialog"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AboutUserRolesModalComponent.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};
AboutUserRolesModalComponent.defaultProps = {
  open: false,
  onClose: () => {},
};

export default AboutUserRolesModalComponent;
